const recruitingAi = {
  productName: 'AI Search',
  statusActive: '策略工作流',
  projectList: '项目列表',
  projectListEmpty: '暂无项目',
  projectListOpen: '开放中',
  projectListDraft: '草稿',
  projectListClosed: '已关闭',
  currentJob: '当前岗位',
  openStrategy: '查看策略',
  closeStrategy: '收起策略',
  strategyPreparing: '策略准备完成后可查看',
  workspaceTabs: {
    label: '招聘工作区',
    agent: 'Agent',
    talentRecommend: '人才推荐',
    jobTalent: '岗位人才',
    selectProjectFirst: '请先选择一个项目',
  },
  insufficientCredits: {
    title: 'AI 积分不足',
    description: '开启新的 Agent 对话需要 20 AI 积分，请先获取更多积分。',
    cancel: '取消',
    getCredits: '获取积分',
  },
  jobCreate: {
    title: '{name}，描述你的招聘需求',
    subtitle:
      '粘贴 JD 或一句话描述 —— 生成搜索策略、即时推荐人才库候选人，或启动 LinkedIn 自动搜索',
    placeholder:
      '例如：「招一位 Senior AI Engineer，3 年以上 LLM / RAG / Agent 经验，上海或远程，英语流利，有开源作品优先」',
    start: '开始招聘',
    startAgentAction: '开启 Agent 对话 · 20 AI积分',
    creating: '创建中...',
    emptyJd: '请输入职位需求',
    createFailed: '创建职位失败',
    uploadJd: '上传 JD',
    uploadUnavailable: '暂未开放',
    talentRecommendTitle: '人才库即时推荐',
    talentRecommendDesc: '融合 GitHub · X · LinkedIn 等公开数据，秒级返回 AI 人才推荐',
    linkedinSearchTitle: 'LinkedIn 自动搜索',
    linkedinSearchDesc: '插件在 Recruiter 页面自动执行搜索计划，简历回流后会自动评分',
    newBadge: 'NEW',
    example1Label: 'Senior AI 工程师',
    example1Prompt:
      '招聘 Senior AI Engineer，3 年以上 LLM / RAG / Agent 工程经验，上海或远程，英语流利，有开源作品优先',
    example2Label: 'SaaS 产品经理',
    example2Prompt:
      '招聘产品经理，5年以上 B2B SaaS 产品经验，上海，有从0到1搭建过企业级产品，熟悉 PLG 增长模式',
    example3Label: 'AI 研究员',
    example3Prompt:
      '招聘 AI Research Engineer，深度学习方向，3年以上 LLM 或计算机视觉经验，Remote 工作，有顶会论文发表优先',
  },
  sidebar: {
    newConversation: '新建会话',
    closedConversation: '已关闭',
  },
  composer: {
    changeCompany: '更换公司',
    executeSearch: '开始搜索',
    searchVersionConfirm: {
      title: '请选择你的领英账号类型',
      confirm: '去配置',
      options: {
        business: '领英个人/商务版(Business)',
        sales: '领英销售版(Sales)',
        recruiter: '领英企业招聘版(Recruiter)',
      },
    },
    searchVersionSelected: '当前已选择 {version} 自动化搜索模式',
    executeHelpReady: '策略和岗位已准备好，可以启动 LinkedIn 搜索自动化。',
    executeHelpBlocked: '先确认并开放岗位，再开始搜索；候选人会绑定到该岗位标签。',
    openJobCta: '确认策略并开放岗位',
    placeholder: '继续调整搜索策略或输入新的指令...',
    hint: 'Enter 发送，Shift + Enter 换行',
    send: '发送',
    stopGenerating: '停止生成',
    startVoiceInput: '语音输入',
    stopVoiceInput: '停止语音输入',
    voiceUnsupported: '当前浏览器不支持语音输入',
    voicePermissionDenied: '未获得麦克风权限，无法使用语音输入',
    voiceFailed: '语音输入失败，请重试',
    voiceNoSpeech: '没有识别到语音内容，请再试一次',
    voiceStatusIdle: '点击麦克风开始语音输入',
    voiceStatusStarting: '正在打开麦克风，请开始说话...',
    voiceStatusListening: '正在听你说话...',
    voiceStatusProcessing: '正在整理语音内容...',
    voiceStatusSuccess: '语音内容已填入输入框',
    voiceStatusEmpty: '没有听清楚，再说一次试试',
    voiceStatusError: '语音输入异常，请重试',
    menus: {
      keywords: {
        label: '关键词',
        items: [
          '收窄核心关键词',
          '扩展相关关键词',
          '添加排除关键词',
          '删除噪音关键词',
          '生成中英文同义词',
        ],
      },
      companies: {
        label: '目标公司',
        items: [
          '只看直接竞品',
          '加中腰部公司',
          '加本地公司',
          '加上游公司',
          '加下游渠道公司',
          '加销售模式趋同公司',
          '加产品类似公司',
          '加相同技术栈公司',
          '加相同行业公司',
          '加相同客户类型公司',
          '加中国关联全球公司',
          '排除某些公司',
        ],
      },
      titles: {
        label: '职位词',
        items: [
          '收窄核心职位词',
          '扩展职位词',
          '加 seniority 变体',
          '按目标公司生成',
          '删除不相关职位词',
        ],
      },
      boolean: {
        label: 'Boolean Search',
        items: [
          '重新生成',
          '更精准',
          '更宽泛',
          '复制',
          '展开完整',
          '按 LinkedIn 优化',
          '按 Google X-Ray 优化',
        ],
      },
      scoring: {
        label: '评分标准',
        items: [
          '编辑匹配项',
          '编辑加分项',
          '编辑风险项',
          '评分更严格',
          '评分更宽松',
          '重写评分标准',
        ],
      },
    },
  },
  chat: {
    introTitle: '已解析 JD，并为你生成 Round 1 搜索策略：',
    role: '岗位',
    location: '地区',
    experience: '经验',
    targetCompanies: '目标公司',
    keywords: '核心关键词',
    jobTitles: '职位词',
    strategyNote: '请点击右侧面板查看详情，或在下方确认策略。',
    confirmTitle: '还有 2 个信息建议确认：',
    defaultStrategy: {
      role: 'Senior Hardware Engineer',
      locationFull: 'Bay Area, CA',
      locationDetail: 'San Jose / Santa Clara',
      experience: '8-12 年',
      targetCompaniesSummary: 'Cisco、Juniper、HPE Aruba +7',
      keywordSummary: 'ASIC Design、FPGA、PCB Layout、Network Switch',
      titleSummary: 'Senior Hardware Systems Engineer、Principal Hardware Engineer',
    },
    defaultQuestions: {
      workAuthorization: {
        title: '1. 是否必须要求美国本地市场经验？',
        mustLocal: '是，必须在美工作',
        flexible: '不限，US Citizen / GC 均可',
        noLimit: '不限制',
      },
      companyScope: {
        title: '2. 目标公司是否只看直接竞品，还是可以扩展到上游芯片公司？',
        directOnly: '只看直接竞品',
        directAndUpstream: '直接竞品 + 上游公司',
        expandPool: '尽量扩大人才池',
      },
    },
    loadingReply: '正在分析并生成回复',
    streamingProgress: '正在处理：{agent}',
    progress: {
      intro: '我先理解一下这次需求，并同步整理候选人范围和搜索策略。',
      default: '正在推进岗位策略',
      routerAgent: '正在理解这个岗位要招什么人',
      jdSplitAgent: '正在提取候选人的硬性要求',
      scoringAgent: '正在生成候选人评分标准',
      targetCompanyAgent: '正在筛选合适的目标公司',
      searchPlanAgent: '正在组合 LinkedIn 搜索策略',
      finalAgent: '正在整理最终建议',
      doneRouterAgent: '已理解岗位方向',
      doneJdSplitAgent: '已提取硬性要求',
      doneScoringAgent: '已生成评分标准',
      doneTargetCompanyAgent: '已筛选目标公司',
      doneSearchPlanAgent: '已整理搜索策略',
      doneFinalAgent: '已准备最终建议',
      parallel: '多个 Agent 正在并行处理',
    },
    backToTop: '回到顶部',
    starter: {
      title: '先把岗位需求发给我，我来帮你创建岗位草稿。',
      desc: '支持直接粘贴 JD、招聘要求，或者用一句话描述想招什么人。我会先拆解岗位，再生成搜索策略和岗位草稿。',
      tip1: '可直接输入岗位名称、地区、级别、目标公司、核心关键词。',
      tip2: '创建岗位对所有用户开放，只有执行搜索时才会校验 Agent 权限。',
      tip3: '如果左侧已有岗位会话，也可以点进去继续补充策略。',
      cards: {
        instantDesc: '基于当前岗位 · 匹配人才库候选人',
        instantRunningDesc: '正在自动推荐 · 候选人陆续出现',
        instantReadyDesc: '已推荐 {count} 位候选人 · 点击查看',
        instantPrompt: '基于当前岗位，先从人才库和公开数据里做即时人才推荐。',
        linkedinDesc: '插件已连接 · 自动执行 LinkedIn 搜索',
        linkedinPrompt: '基于当前岗位，生成 LinkedIn 自动搜索计划并准备启动插件搜索。',
      },
      examples: {
        jdTitle: '粘贴 JD',
        jdPrompt: '帮我创建一个岗位，我马上贴 JD，你先帮我拆解关键信息并生成搜索策略。',
        shortTitle: '一句话创建',
        shortPrompt:
          '帮我创建一个美国市场的 Senior SDR 岗位，base 在 Bay Area，优先看 SaaS 背景候选人。',
        companyTitle: '按目标公司建岗',
        companyPrompt:
          '帮我创建一个 Java 后端岗位，优先看电商、支付和交易系统背景，目标公司可以先从头部互联网公司开始。',
      },
    },
  },
  message: {
    aiName: 'Recruiter Brain',
    you: '你',
    intakeHint: '岗位已创建。请一次补充以下信息，完成后将继续完成岗位分析和搜索策略。',
    intakeManual: '我自己填写',
    intakeManualPlaceholder: '输入你的补充信息',
    intakeConfirmAndGenerate: '确认并生成',
    intakeSkipAndGenerate: '跳过并生成',
    intakeSubmissionHeading: '已确认补充信息',
    intakeUnavailable: '暂不提供',
    thinkingChain: '查看处理过程',
    thinkingProcess: '处理过程',
    thinkingHint: 'Agent 正在整理策略步骤……',
    workingTask: '正在推进任务，请稍候……',
  },
  messages: {
    loadingHistory: '正在加载该岗位的历史会话...',
    loadOlderHistory: '加载更早记录',
    loadingOlderHistory: '正在加载...',
    emptyHistory: '该岗位暂时没有历史会话，可以继续输入指令。',
    loadHistoryFailed: '历史会话加载失败，请稍后重试。',
    sendFailed: '消息发送失败，请稍后重试。',
    strategyRetryableFailed: '刚才没有完整理解这次调整，请换一种说法再发一次。',
    strategyIncomplete: '这次策略没有处理完整，请再发送一次，或补充更明确的岗位要求。',
    targetCompanyNeedMoreContext: '目标公司范围还不够明确，请补充行业、竞品或你希望优先看的公司。',
    searchPlanNeedRetry: '搜索策略还没有准备完整，请稍后重试或补充更具体的筛选条件。',
    strategyBusy: '当前策略调整次数较多，请稍后再试一次。',
    intakeRecorded: '已记录：{question} {answer}',
    intakeSkipped: '已跳过：{question}',
    intakeFormRecorded: '已完成信息确认：填写 {provided} 项，跳过 {skipped} 项。',
    generationStopped: '已停止生成。',
    runStillProcessing: '这个岗位还在后台处理中，我会继续同步最新状态。',
    runRecoveredFailed: '上次后台处理失败，已同步可用结果。',
    runRecoveredCanceled: '上次处理已取消。',
    strategyGeneratedReply: '搜索策略已生成，右侧策略面板已更新。你可以继续告诉我想调整的方向。',
    strategyReadySummary:
      '搜索策略已准备就绪，可以直接开始自动化 LinkedIn 搜索。\n\n当前策略概要：\n\n目标公司：{companies}\n搜索模式：{searchMode}\n关键词：{keywords} 为核心，辅以分布式系统、微服务等技术词\n职位：{titles} 等\n评分标准：已设定必备、加分项和风险筛选条件\n\n你可以直接开始搜索，也可以先调整目标公司、关键词、职位词、评分标准或搜索计划。',
    companyFirstSearchMode: '公司优先，在{company}内部寻找{role}',
    backgroundRefinementPending: '目标公司正在后台优化中，你可以继续调整策略或直接继续对话。',
    targetCompaniesGenerating:
      '目标公司正在后台生成中，预计约 1 分钟完成，页面会自动更新。当前可以先开放岗位，完成前暂不能开始自动化搜索。',
    targetCompaniesReady: '目标公司已生成，可以开始自动化 LinkedIn 搜索。',
    targetCompaniesReadyWithCount: '目标公司已生成，共 {count} 家，可以开始自动化 LinkedIn 搜索。',
    targetCompaniesCompletedEmpty:
      '目标公司补充已完成，但这次没有找到可新增的公司。你可以先用当前搜索策略继续，或补充行业/竞品线索后再调整。',
    draftGeneratedTitle: '在开始搜索前，确认是否新建岗位项目：',
    confirmOpenJob: '确认开放岗位',
    confirmOpenAndStartSearch: '确认新建',
    prepareStrategyFirst: '继续沟通',
    prepareStrategyReply: '确定和我沟通清楚后，右下角点击「开始搜索」',
    openJobLoading: '开放中...',
    jobOpened: '已开放岗位',
    missingJobId: '缺少岗位 ID，无法确认开放岗位',
    openJobFirst: '请先开放岗位后再执行搜索',
    extensionRequired: '请先安装并连接 EasyHireAI Extension，再启动自动化搜索',
    aiSourcingMembershipRequired: 'AI 搜寻实验室需要开通基础会员或以上套餐后使用。',
    businessSearchUrlMissing: '当前策略缺少 Business 搜索链接，请先重新生成搜索策略。',
    salesSearchUnavailable: '销售版暂未开放。',
    openJobSuccess: '岗位已开放：{name}\n现在可以导入候选人并继续启动自动化搜索。',
    openJobSuccessTargetPending:
      '岗位已开放：{name}\n目标公司正在后台生成中，预计约 1 分钟完成。完成前暂不能开始自动化搜索，你可以继续调整岗位策略。',
    openJobSuccessAction: '开始搜索',
    executeConfirmTitle: '确认启动搜索',
    executeConfirmButton: '确认并开始',
    executeCreateTagConfirm: '将创建标签：{tagName}',
    extensionInstallTitle: '安装 EasyHire AI',
    extensionInstallConfirm: '前往安装',
    extensionInstallStoreName: 'chrome web store',
    extensionInstallPreviewTitle: 'EasyHire AI - 招聘自动化与候选人联系...',
    extensionInstallFeatured: '精选',
    extensionInstallRating: '4.8（100+ 评分）',
    extensionInstallTagExtension: 'Extension',
    extensionInstallTagTools: 'Tools',
    extensionInstallUsers: '150M+ 全球人才库',
    extensionInstallOpened: 'Extension 安装页已打开。安装并启用后回到本页，系统会自动检测并继续。',
    extensionStillMissing:
      '仍未检测到 EasyHireAI Extension。请确认 Extension 已安装并启用，然后重新点击开始搜索。',
    extensionStillMissingTitle: 'Extension 未连接',
    openJobFailed: '开放岗位失败，请稍后重试。该岗位目前仍会保留为草稿。',
    openJobFailedTitle: '开放岗位失败',
    jobCreateStillProcessing: '岗位创建还在进行中，完成后才能推荐人才。',
    searchPlanNeedsDetails: '岗位分析流程尚未完成，请先回答会话中待补充的信息。',
    executeDisabled: '自动化搜索入口暂未开放，等插件联调完成后再启用。',
    executeSearchMembershipRequired: '自动化搜索需要有效会员，正在前往订阅页面。',
    automationStarted: '自动化流程已启动！正在创建标签并打开 LinkedIn 搜索页面...',
    alreadyInCreateFlow: '你已经在创建岗位会话中，可以直接继续输入招聘需求。',
    alreadyEditingJob: '你已经在编辑该岗位会话中，可以直接继续调整。',
  },
  replyTemplates: {
    searchFiltersUpdated: '已更新搜索筛选条件:',
    workAuthorizationRequirement: '工作身份要求',
    strategyStillDraft: '当前策略仍为 Draft，可以继续调整。',
    targetCompanyStrategyUpdated: '已更新目标公司策略:',
    companyScope: '公司范围',
    upstreamExcluded: '上游芯片公司（Broadcom / Marvell）暂不加入本轮目标公司池。',
    upstreamIncluded: '上游芯片公司（Broadcom / Marvell）已加入目标公司池。',
  },
  strategy: {
    title: '搜索策略',
    subtitle: '第 1 轮搜索策略',
    summaryTitle: '策略概览',
    healthNeedsInput: '待补充',
    healthReady: '就绪',
    healthSearchable: '可搜索',
    healthWaitingTitle: '等待策略生成',
    healthWaitingMessage: '请先输入岗位信息，AI 才能构建搜索策略。',
    healthReadyTitle: '可以开始搜索',
    healthReadyMessage: '岗位、搜索计划、目标公司、关键词、约束条件和评分框架均已就绪。',
    healthSearchableTitle: '核心策略已就绪',
    healthSearchableMessage: '核心计划已准备好；补充下方缺失项可提升候选人质量。',
    healthNotReadyTitle: '尚未就绪',
    healthNotReadyMessage: '请先确认岗位和搜索计划，再执行候选人搜索。',
    metricOk: '正常',
    metricMissing: '缺失',
    gapRole: '岗位未识别',
    gapPlan: '搜索计划缺失',
    gapCompanies: '目标公司缺失',
    gapKeywords: '关键词缺失',
    gapScoring: '评分框架缺失',
    autoSaved: '已自动保存',
    needConfirm: '还有 2 项待确认',
    resizeAria: '调整策略抽屉宽度',
    resizeTitle: '拖动调整宽度',
    empty: '暂无数据',
    jdBreakdown: 'JD 拆解',
    role: '岗位',
    function: '职能',
    seniority: '职级',
    hiringCompany: '招聘公司',
    coreRequirements: '核心岗位要求',
    searchFilters: '搜索筛选条件',
    targetCompanies: '目标公司',
    finalStrategyText: '最终策略文本',
    jobTitles: '职位词',
    primaryTitles: '核心职位词',
    expandedTitles: '扩展职位词',
    suggestedByCompany: '按公司推荐职位词',
    booleanPreview: '布尔搜索预览',
    generated: '已生成',
    generating: '生成中',
    notUsedInSearch: '未参与搜索',
    targetCompaniesInactiveHint:
      '目标公司池已保留作为历史数据，当前 Recruiter 和 Sales Navigator 自动化均不使用公司筛选。',
    expandReason: '展开原因',
    collapseReason: '收起原因',
    targetCompaniesGeneratingTitle: '目标公司正在生成',
    targetCompaniesGeneratingEta: '约 1 分钟',
    targetCompaniesGeneratingHint:
      '目标公司正在后台生成中，预计约 1 分钟完成，页面会自动更新。完成前可以继续开放岗位或调整策略，暂不能开始自动化搜索。',
    targetCompaniesProgressAccessible: '目标公司正在补充中',
    targetCompaniesProgressResearching: '目标公司正在补充中 · 正在分析候选公司',
    targetCompaniesProgressCount: '目标公司正在补充中 · 已发现 {count} 家',
    targetCompaniesProgressFinalizing: '已发现 {count} 家目标公司 · 正在整理搜索策略',
    targetCompaniesCompletedEmpty: '已完成，暂无可新增公司',
    roundPlan: '搜索计划',
    roundActive: '第 1 轮进行中',
    roundFallback: '第 {index} 轮',
    guardrails: '搜索约束',
    hardRequirements: '硬性要求',
    keywords: '关键词',
    excludeKeywords: '排除关键词',
    excludedCompanies: '低价值 / 排除公司',
    instantRecommend: '即时推荐',
    instantRecommendUnavailable: '即时推荐暂未开放',
    startAutomation: '开始自动搜索',
    scoringFramework: '评分标准',
    roleSummary: '岗位概述',
    candidateTiers: '候选人分层',
    tierFallback: 'Tier {tier}',
    mustHave: '必备项',
    preferred: '加分项',
    penalty: '风险项',
    companiesCount: '{count} 家公司',
    excludedCompanyGroup: '排除 / 低价值公司',
    noise: '噪音度',
    competitor: '竞品度',
    whyRelevant: '推荐原因',
    transferLogic: '人才迁移逻辑',
    filters: {
      geo: '地区',
      industry: '行业',
      seniority: '职级',
      role: '岗位',
      function: '职能',
      companyPreference: '公司偏好',
      language: '语言',
      yearsOfExperience: '工作年限',
    },
    fields: {
      role: '岗位',
      function: '职能',
      level: '级别',
      hiringCompany: '招聘公司',
      domain: '领域',
      location: '地区',
      keyword: '关键词',
      title: '职位',
      entry: '入口策略',
      language: '语言',
      company: '公司',
      years: '年限',
      industry: '行业',
    },
  },
  toolCall: {
    addCompany: '添加公司',
    deleteCompany: '删除公司',
    generateSearchPlan: '生成搜索方案',
    setRouterTarget: '设置路由目标',
    addingCompany: '正在添加 {name}',
    addedCompany: '已添加 {name}',
    deletingCompany: '正在删除 {name}',
    deletedCompany: '已删除 {name}',
    generatingPlan: '正在生成搜索方案',
    planGenerated: '搜索方案已生成',
    settingTarget: '正在设置搜索目标',
    targetSet: '搜索目标已设置',
    genericRunning: '正在执行 {tool}',
    genericDone: '已完成 {tool}',
    roundSuffix: '（第 {round} 轮）',
    routerAgent: {
      running: '正在理解需求并安排下一步',
      done: '已确定下一步处理方向',
    },
    finalAgent: {
      running: '正在整理最终回复',
      done: '回复已准备好',
    },
    createJob: {
      running: '正在创建岗位草稿',
      done: '岗位草稿已创建',
    },
    updateJob: {
      running: '正在更新岗位信息',
      done: '岗位信息已更新',
    },
    updateSearchStrategy: {
      running: '正在更新搜索策略',
      done: '搜索策略已更新',
    },
    setSearchTarget: {
      running: '正在确定处理目标',
      done: '处理目标已确定',
    },
    saveSearchStrategy: {
      running: '正在保存搜索策略',
      done: '搜索策略已保存',
    },
    analyzeJobDescription: {
      running: '正在拆解岗位需求',
      done: '岗位需求已拆解',
    },
    generateBooleanSearch: {
      running: '正在生成布尔搜索式',
      done: '布尔搜索式已生成',
    },
    searchCandidates: {
      running: '正在准备候选人搜索',
      done: '候选人搜索已准备好',
    },
    generic: {
      running: '正在处理当前步骤',
      done: '当前步骤已完成',
    },
  },
  score: {
    criteriaCount: '{count} 条标准',
  },
}

export default recruitingAi
